import { getChatUrl } from "../../api";

interface IProps {
  height?: number;
  videoId: string | undefined;
  token: string;
}

export default function StudioLiveChat({ videoId, token }: IProps) {
  const CHAT_URL = getChatUrl(videoId!, token);

  if (!videoId) return null;

  return (
    <div className="h-[calc(100vh-30px)] overflow-hidden rounded-2xl border bg-white">
      <iframe
        title="KGS Live Chat"
        src={CHAT_URL}
        frameBorder={0}
        allowFullScreen
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          background: "#fff",
          display: "block",
        }}
      />
    </div>
  );
}
